import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Typography from '@mui/material/Typography';
import { CONSTANTS } from '../../../constants/constants';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { NRHandleEmptyCellValue } from '../CellComponent/CellComponent';

export const MaturityFormatter = ({ value }) => {
  return (
    <Typography variant="body2">
      <NRHandleEmptyCellValue value={CONSTANTS.TABLE.VULNERABILITIES_TABLE.MATURITY_MAP[value?.toUpperCase()] || capitalizeFirstLetter(value)} />
    </Typography>
  );
};
export const MaturityProvider = props => <DataTypeProvider formatterComponent={MaturityFormatter} {...props} />;
